var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"market-watch"}},[(_vm.show)?_c('button',{staticClass:"market-watch",class:_vm.classModifiers,attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.onWatchToggle($event)}}},[_vm._v("\n     \n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0f1096e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-watch/market-watch.vue
// module id = gYFg
// module chunks = 0